/* @generated */

// src/assets/ui-icon/external-logo/microsoft-edge.tsx
import * as React from "react";
var MicrosoftEdgeExternalLogo = (props) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", ...props }, /* @__PURE__ */ React.createElement(
  "path",
  {
    d: "M13.472 13.352a.504.504 0 0 0 .048-.05c.316-.41.488-.908.488-1.243 0-.024 0-.05-.002-.078v.002a1.992 1.992 0 0 0-.397-1.166 2.023 2.023 0 0 0-1.606-.813c-.426-.007-.75.146-.948.24l-.023.01a1.968 1.968 0 0 0-1.027 1.707c0 2.61 2.576 4.644 5.533 4.644a6.366 6.366 0 0 0 2.244-.403c.226-.085.445-.183.659-.295a.25.25 0 0 1 .332.353 8.02 8.02 0 0 1-4.162 3.3l-.082.027a6.111 6.111 0 0 1-.546.141c.186-.035.371-.081.554-.139a8 8 0 0 1-9.774-4.193 8.133 8.133 0 0 1-.756-3.5c0-.167.012-.335.035-.504a3.36 3.36 0 0 0-.042.483A7.999 7.999 0 0 1 12 4c3.108 0 5.967 1.49 7.29 4.08l.036.068c.226.442.689 1.348.674 2.676a3.835 3.835 0 0 1-1.902 3.305c-.573.34-1.226.52-1.892.522h-.002c-.058.002-1.711.072-2.595-.543-.189-.132-.295-.289-.295-.452 0-.152.093-.24.158-.304Z",
    fill: "currentColor",
    vectorEffect: "non-scaling-stroke"
  }
));
export {
  MicrosoftEdgeExternalLogo
};
